import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-efb5ef46"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "news-box"
};
const _hoisted_2 = {
  class: "module-top"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  class: "news-list"
};
const _hoisted_6 = {
  key: 0,
  class: "news-info"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "news-right"
};
const _hoisted_9 = {
  class: "name"
};
const _hoisted_10 = {
  class: "content"
};
const _hoisted_11 = {
  class: "news-time"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "time"
};
export default {
  props: {
    menu: Object
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    const $utils = inject('$utils');
    const mainRecommendNews = ref({});
    const newsList = ref([]); // 增加观看次数

    const addViewCount = async id => {
      const res = await $http.addViewCount({
        id
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      console.log('count', res);
    };

    const handleDetail = item => {
      if (item.news_type === 1) {
        window.location.href = `/noticeDetail.html?id=${item.id}&name=${props.menu.module_name}&menuId=${props.menu.menu_id}`;
      } else {
        addViewCount(item.id);
        window.open(item.news_url);
      }
    };

    const getNewsList = async () => {
      const res = (await $http.getHomeNews({
        num: props.menu.num,
        menu_id: props.menu.menu_id
      })) || [];
      console.log('新闻-首页', res);

      if (res.length && res.length <= 4 && res[0].news_cover_url) {
        mainRecommendNews.value = res.shift();
      }

      newsList.value = res;
    };

    getNewsList();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.menu.module_name), 1), _createElementVNode("a", {
        href: `/notice.html?name=${__props.menu.module_name}&menuId=${__props.menu.menu_id}`,
        class: "right"
      }, " 全部> ", 8, _hoisted_4)]), _createElementVNode("ul", _hoisted_5, [mainRecommendNews.value.news_cover_url ? (_openBlock(), _createElementBlock("li", _hoisted_6, [_createElementVNode("img", {
        src: mainRecommendNews.value.news_cover_url,
        class: "news-cover",
        alt: ""
      }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(mainRecommendNews.value.news_name), 1), _createElementVNode("p", _hoisted_10, _toDisplayString(_unref($utils).getContentText(mainRecommendNews.value.context)), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("time", null, _toDisplayString(_unref($utils).formatDate(mainRecommendNews.value.publish_time, 'YYYY/MM/DD')), 1), _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = $event => handleDetail(mainRecommendNews.value)),
        class: "link"
      }, "查看详情 >")])])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, item => {
        return _openBlock(), _createElementBlock("li", {
          class: "news-item",
          key: item.id,
          onClick: $event => handleDetail(item)
        }, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.news_name), 1), _createElementVNode("time", _hoisted_14, _toDisplayString(_unref($utils).formatDate(item.publish_time, 'YYYY/MM/DD')), 1)], 8, _hoisted_12);
      }), 128))])]);
    };
  }

};